var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V496H496V336H16Z",
    fill: "#2ECC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 176V336H496V176H16Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V176H496V16H16Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.301 366.625C240.393 366.625 289.918 317.1 289.918 256.008C289.918 194.916 240.393 145.391 179.301 145.391C118.209 145.391 68.6835 194.916 68.6835 256.008C68.6835 317.1 118.209 366.625 179.301 366.625Z",
    fill: "#F1C40F",
    stroke: "#222222",
    strokeWidth: 3.75025
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.55 272.509H198.052H160.55ZM160.55 244.758H198.052H160.55ZM179.301 145.751V334.764Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.301 145.751V334.764M160.55 272.509H198.052H160.55ZM160.55 244.758H198.052H160.55Z",
    stroke: "#222222",
    strokeWidth: 4.5003
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.763 357.579C179.909 376.015 222.225 358.712 222.225 358.712C222.225 358.712 206.251 341.425 198.063 334.675C190.072 328.091 166.567 328.351 158.546 334.675C151.853 339.954 132.654 359.404 134.763 357.579V357.579Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.301 325.012C186.136 325.012 191.677 316.953 191.677 307.011C191.677 297.069 186.136 289.01 179.301 289.01C172.466 289.01 166.925 297.069 166.925 307.011C166.925 316.953 172.466 325.012 179.301 325.012Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.301 268.129C187.586 268.129 194.302 263.878 194.302 258.633C194.302 253.389 187.586 249.138 179.301 249.138C171.016 249.138 164.3 253.389 164.3 258.633C164.3 263.878 171.016 268.129 179.301 268.129Z",
    fill: "#222222"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M179.301 229.756C187.586 229.756 194.302 223.04 194.302 214.755C194.302 206.47 187.586 199.754 179.301 199.754C171.016 199.754 164.3 206.47 164.3 214.755C164.3 223.04 171.016 229.756 179.301 229.756Z",
    fill: "#262626"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.302 158.876C197.298 158.866 198.602 161.03 195.867 165.954C182.797 189.493 169.681 190.001 167.191 192.028C164.448 194.262 163.29 194.109 163.29 194.109C163.485 192.093 163.668 183.849 163.811 183.055C165.795 172.057 182.409 172.208 195.412 160.947C197.443 159.188 197.298 158.866 197.298 158.866L197.302 158.876Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.424 209.505C153.424 209.505 156.36 217.928 156.799 226.381C157.501 239.879 170.435 240.257 179.301 240.257V232.756C172.656 232.756 166.885 231.769 162.05 221.881C159.664 217.003 153.424 209.505 153.424 209.505Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.049 318.263C153.049 318.263 157.772 312.438 163.296 298.78C166.179 291.654 173.009 287.51 179.301 287.51V277.01C165.029 277.01 158.187 282.302 157.465 290.033C155.982 305.917 153.049 318.263 153.049 318.263Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNc);
export default __webpack_public_path__ + "static/media/NC.43bd59206a24a4dc43e3690d574c7727.svg";
export { ForwardRef as ReactComponent };